import type { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar-common';

/**
 * Initial AGM tech radar snapshot. Client-side static data — no
 * tech-radar-backend required. Owners should update this file (or move to
 * a backend-fed source later) as adoption calls change; see
 * docs/plugins/README.md.
 */
const timestamp = (): Date => new Date('2026-07-29T00:00:00Z');

export const agmTechRadarData: TechRadarLoaderResponse = {
  quadrants: [
    { id: 'languages', name: 'Languages & Frameworks' },
    { id: 'infrastructure', name: 'Infrastructure' },
    { id: 'platforms', name: 'Platforms & Tools' },
    { id: 'data-ai', name: 'Data & AI' },
  ],
  rings: [
    { id: 'adopt', name: 'ADOPT', color: '#5ba300' },
    { id: 'trial', name: 'TRIAL', color: '#009eb0' },
    { id: 'assess', name: 'ASSESS', color: '#c7ba00' },
    { id: 'hold', name: 'HOLD', color: '#e09b96' },
  ],
  entries: [
    {
      key: 'typescript',
      id: 'typescript',
      quadrant: 'languages',
      title: 'TypeScript',
      timeline: [{ date: timestamp(), ringId: 'adopt', moved: 0 }],
      links: [],
    },
    {
      key: 'react',
      id: 'react',
      quadrant: 'languages',
      title: 'React',
      timeline: [{ date: timestamp(), ringId: 'adopt', moved: 0 }],
      links: [],
    },
    {
      key: 'dotnet-mvc5',
      id: 'dotnet-mvc5',
      quadrant: 'languages',
      title: '.NET Framework / ASP.NET MVC 5',
      timeline: [{ date: timestamp(), ringId: 'hold', moved: 0 }],
      links: [],
    },
    {
      key: 'python-flask',
      id: 'python-flask',
      quadrant: 'languages',
      title: 'Python + Flask',
      timeline: [{ date: timestamp(), ringId: 'trial', moved: 0 }],
      links: [],
    },
    {
      key: 'aws-ecs',
      id: 'aws-ecs',
      quadrant: 'infrastructure',
      title: 'AWS ECS (EC2 launch type)',
      timeline: [{ date: timestamp(), ringId: 'adopt', moved: 0 }],
      links: [],
    },
    {
      key: 'postgres',
      id: 'postgres',
      quadrant: 'infrastructure',
      title: 'PostgreSQL',
      timeline: [{ date: timestamp(), ringId: 'adopt', moved: 0 }],
      links: [],
    },
    {
      key: 'github-actions',
      id: 'github-actions',
      quadrant: 'platforms',
      title: 'GitHub Actions',
      timeline: [{ date: timestamp(), ringId: 'adopt', moved: 0 }],
      links: [],
    },
    {
      key: 'backstage',
      id: 'backstage',
      quadrant: 'platforms',
      title: 'Backstage (self-hosted IDP)',
      timeline: [{ date: timestamp(), ringId: 'adopt', moved: 0 }],
      links: [],
    },
    {
      key: 'litellm',
      id: 'litellm',
      quadrant: 'data-ai',
      title: 'LiteLLM',
      timeline: [{ date: timestamp(), ringId: 'trial', moved: 0 }],
      links: [],
    },
    {
      key: 'langfuse',
      id: 'langfuse',
      quadrant: 'data-ai',
      title: 'Langfuse',
      timeline: [{ date: timestamp(), ringId: 'assess', moved: 0 }],
      links: [],
    },
  ],
};
